export const navItems = [
  {
    id: 1,
    path: "/",
    title: "Home",
  },
  {
    id: 2,
    path: "#about",
    title: "About",
  },
  {
    id: 3,
    path: "#tech",
    title: "Tech Stack",
  },
  {
    id: 4,
    path: "#projects",
    title: "Projects",
  },
  {
    id: 5,
    path: "#contact",
    title: "Contact",
  },
];
